import { c as _c } from "react/compiler-runtime";
import { FormEvent, ReactElement, memo, useEffect, useMemo, useState } from 'react';
import { ProductReviewRatingDistributionEntry, ProductReviewSortCode } from '@spa/generated/graphql/graphql';
import DropdownComponent from '@spa/components/dropdown/dropdown.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './bazaarvoice-review-toolbar.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export const ALL_RATINGS_FILTER_VALUE = 'all';
export const SORT_OPTIONS: ReadonlyArray<ProductReviewSortCode> = [ProductReviewSortCode.MOST_RELEVANT, ProductReviewSortCode.NEWEST, ProductReviewSortCode.HIGHEST_RATING, ProductReviewSortCode.LOWEST_RATING, ProductReviewSortCode.MOST_HELPFUL];
export interface Props {
  readonly id: string;
  readonly searchText: string;
  readonly sort: ProductReviewSortCode;
  readonly ratingFilterValue: string;
  readonly ratingDistribution: ReadonlyArray<ProductReviewRatingDistributionEntry>;
  readonly onSearchSubmit: (searchText: string) => void;
  readonly onSortChange: (sort: ProductReviewSortCode) => void;
  readonly onRatingFilterChange: (ratingFilterValue: string) => void;
  readonly disabled?: boolean;
}
function BazaarvoiceReviewToolbarComponent(t0) {
  const $ = _c(77);
  const {
    id,
    searchText,
    sort,
    ratingFilterValue,
    ratingDistribution,
    onSearchSubmit,
    onSortChange,
    onRatingFilterChange,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  const [searchInputValue, setSearchInputValue] = useState(searchText);
  let t2;
  if ($[0] !== ratingDistribution) {
    t2 = [ALL_RATINGS_FILTER_VALUE, ...[...ratingDistribution].sort(_temp).map(_temp2)];
    $[0] = ratingDistribution;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const ratingFilterValues = t2;
  const selectedFilterIdx = Math.max(0, ratingFilterValues.indexOf(ratingFilterValue));
  let t3;
  if ($[2] !== sort) {
    t3 = SORT_OPTIONS.indexOf(sort);
    $[2] = sort;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedSortIdx = Math.max(0, t3);
  let t4;
  let t5;
  if ($[4] !== onRatingFilterChange || $[5] !== ratingFilterValue || $[6] !== ratingFilterValues) {
    t4 = () => {
      if (!ratingFilterValues.includes(ratingFilterValue)) {
        onRatingFilterChange(ALL_RATINGS_FILTER_VALUE);
      }
    };
    t5 = [ratingFilterValues, ratingFilterValue, onRatingFilterChange];
    $[4] = onRatingFilterChange;
    $[5] = ratingFilterValue;
    $[6] = ratingFilterValues;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== onSearchSubmit || $[10] !== searchInputValue) {
    t6 = event => {
      event.preventDefault();
      onSearchSubmit(searchInputValue.trim());
    };
    $[9] = onSearchSubmit;
    $[10] = searchInputValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleSearchSubmit = t6;
  let t7;
  if ($[12] !== formatMessage) {
    t7 = formatMessage("toolbarHeadline");
    $[12] = formatMessage;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <h3 className="bold">{t7}</h3>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== formatMessage) {
    t9 = formatMessage("searchPlaceholder");
    $[16] = formatMessage;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== formatMessage) {
    t10 = formatMessage("searchPlaceholder");
    $[18] = formatMessage;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event_0 => setSearchInputValue(event_0.target.value);
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== disabled || $[22] !== searchInputValue || $[23] !== t10 || $[24] !== t9) {
    t12 = <input type="search" className={styles["bazaarvoice-review-toolbar__search-input"]} placeholder={t9} aria-label={t10} value={searchInputValue} disabled={disabled} onChange={t11} />;
    $[21] = disabled;
    $[22] = searchInputValue;
    $[23] = t10;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== formatMessage) {
    t13 = formatMessage("searchButtonAriaLabel");
    $[26] = formatMessage;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ImageComponent src="/assets/icons/search-white.svg" alt="" width={20} height={20} />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== disabled || $[30] !== t13) {
    t15 = <button type="submit" className={styles["bazaarvoice-review-toolbar__search-button"]} aria-label={t13} disabled={disabled}>{t14}</button>;
    $[29] = disabled;
    $[30] = t13;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== handleSearchSubmit || $[33] !== t12 || $[34] !== t15) {
    t16 = <form className={styles["bazaarvoice-review-toolbar__search"]} role="search" onSubmit={handleSearchSubmit}>{t12}{t15}</form>;
    $[32] = handleSearchSubmit;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = `${id}-filter`;
  const t18 = `filterOption.${ratingFilterValues[selectedFilterIdx]}`;
  let t19;
  if ($[36] !== formatMessage || $[37] !== t18) {
    t19 = formatMessage(t18);
    $[36] = formatMessage;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19) {
    t20 = <span>{t19}</span>;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== onRatingFilterChange || $[42] !== ratingFilterValues) {
    t21 = clickedItemIdx => onRatingFilterChange(ratingFilterValues[clickedItemIdx]);
    $[41] = onRatingFilterChange;
    $[42] = ratingFilterValues;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== formatMessage || $[45] !== ratingFilterValues) {
    t22 = ratingFilterValues.map(value => <span key={value}>{formatMessage(`filterOption.${value}`)}</span>);
    $[44] = formatMessage;
    $[45] = ratingFilterValues;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== disabled || $[48] !== selectedFilterIdx || $[49] !== t17 || $[50] !== t20 || $[51] !== t21 || $[52] !== t22) {
    t23 = <DropdownComponent id={t17} stretchToParent={true} disabled={disabled} placeholder={t20} initialSelectedItem={selectedFilterIdx} onClick={t21}>{t22}</DropdownComponent>;
    $[47] = disabled;
    $[48] = selectedFilterIdx;
    $[49] = t17;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  const t24 = `${id}-sort`;
  const t25 = `sortOption.${SORT_OPTIONS[selectedSortIdx]}`;
  let t26;
  if ($[54] !== formatMessage || $[55] !== t25) {
    t26 = formatMessage(t25);
    $[54] = formatMessage;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t26) {
    t27 = <span>{t26}</span>;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== onSortChange) {
    t28 = clickedItemIdx_0 => onSortChange(SORT_OPTIONS[clickedItemIdx_0]);
    $[59] = onSortChange;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== formatMessage) {
    t29 = SORT_OPTIONS.map(sortOption => <span key={sortOption}>{formatMessage(`sortOption.${sortOption}`)}</span>);
    $[61] = formatMessage;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== disabled || $[64] !== selectedSortIdx || $[65] !== t24 || $[66] !== t27 || $[67] !== t28 || $[68] !== t29) {
    t30 = <DropdownComponent id={t24} stretchToParent={true} disabled={disabled} placeholder={t27} initialSelectedItem={selectedSortIdx} onClick={t28}>{t29}</DropdownComponent>;
    $[63] = disabled;
    $[64] = selectedSortIdx;
    $[65] = t24;
    $[66] = t27;
    $[67] = t28;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t23 || $[71] !== t30) {
    t31 = <div className={styles["bazaarvoice-review-toolbar__controls"]}>{t23}{t30}</div>;
    $[70] = t23;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t16 || $[74] !== t31 || $[75] !== t8) {
    t32 = <div className={styles["bazaarvoice-review-toolbar"]}>{t8}{t16}{t31}</div>;
    $[73] = t16;
    $[74] = t31;
    $[75] = t8;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  return t32;
}
function _temp2(t0) {
  const {
    rating
  } = t0;
  return String(rating);
}
function _temp(a, b) {
  return b.rating - a.rating;
}
export default memo(BazaarvoiceReviewToolbarComponent);